import { Controller } from "@hotwired/stimulus"

export default class TrialBannerController extends Controller {
  static targets = ["banner"]
  static values = { dismissedKey: String }

  declare readonly bannerTarget: HTMLElement
  declare dismissedKeyValue: string

  connect(): void {
    if (localStorage.getItem(this.dismissedKeyValue) === "true") {
      this.bannerTarget.classList.add("hidden")
    }
  }

  dismiss(): void {
    this.bannerTarget.classList.add("hidden")
    localStorage.setItem(this.dismissedKeyValue, "true")
  }
}
